module.exports = __webpack_public_path__ + "9730aeade49f42d0a81811c191c4cf6a.svg";